import { render, staticRenderFns } from "./events-list.vue?vue&type=template&id=b926d956&lang=pug"
import script from "./events-list.vue?vue&type=script&lang=coffee"
export * from "./events-list.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports